import QuickLinkCard from '@atoms/QuickLinkCard/QuickLinkCard';
import { IQuickLinks } from '@models/IQuickLinks';
import NavigationCarousel from '@molecules/NavigationCarousel/NavigationCarousel';
import { SwiperSlide } from 'swiper/react';

const QuickLinks = ({ id, cards, title }: IQuickLinks) => {
  const displayedCards = cards.filter(
    (card) => card?.link?.url && card?.link?.name
  );

  return (
    <section
      className="component-padding overflow-hidden bg-white text-black-100 dark:bg-black-100 dark:text-white"
      data-testid="CT-142-QuickLinks"
    >
      <NavigationCarousel
        id={`Quick-Links-Carousel-${id}`}
        items={displayedCards}
        shadows
        slidesToShowMobile={2.3}
        slidesToShowTablet={4}
        slidesToShowDesktop={5}
        title={title}
        titleClassName="h3"
      >
        {(itemsToDisplay) =>
          itemsToDisplay.map((card, index) => (
            <SwiperSlide key={card?.link?.name} className="stretch-card">
              <QuickLinkCard
                {...card}
                dataTestId={`CT-142-QuickLinks-Card-${index}`}
              />
            </SwiperSlide>
          ))
        }
      </NavigationCarousel>
    </section>
  );
};

export default QuickLinks;
